import { TabOption, Tabs } from 'src/components/molecules/DataBox/Tabs';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';

export type MetricOption = 'modelledConversions' | 'spend';

type MediaMatrixTabsProps = {
  selectedTab: MetricOption;
  onSelect: (value: MetricOption) => void;
};

export const MediaMatrixTabs: React.FC<MediaMatrixTabsProps> = ({
  onSelect,
  selectedTab,
}) => {
  const { metricLabel } = useKpiMetricLabels();

  // Metric-aware label — KPI metrics are dynamic per model
  const tabs: Array<TabOption<MetricOption>> = [
    {
      label: 'Spend',
      value: 'spend',
    },
    {
      label: `Modelled Media-Driven ${metricLabel}`,
      value: 'modelledConversions',
    },
  ];

  return <Tabs selectedTab={selectedTab} onSelect={onSelect} options={tabs} />;
};
